import { put } from '@redux-saga/core/effects';
import { NotificationType } from '../Notifications';
import { addNotification } from '../Notifications/redux/actionCreators';
export function putErrorNotification(message) {
    return put(addNotification(NotificationType.Generic, {
        message: message,
        isError: true,
        cardProps: {
            withShadow: true,
            multiLine: true,
            duration: 10000,
        },
    }));
}
//# sourceMappingURL=saga.js.map